// @flow
import { generatePath } from 'react-router-dom'
import { COURSE_LANDING } from 'modules/landings/routes-map'
import { AppOptionsService } from 'services/app-options'

import type { HistoryBlocker, HistoryBlockerObject } from '../../types'

const AB_TEST = '20210618_16324'
const AB_TEST_COURSE_LANDING_ID = 4026
const AB_TEST_COURSE_LANDING_URL = generatePath(COURSE_LANDING, { course_id: AB_TEST_COURSE_LANDING_ID })
const AB_TEST_COURSE_LANDING_REGEXP = new RegExp(AB_TEST_COURSE_LANDING_URL.replace(/\//g, '\\/'))

/**
 * Checks if a user participates in the corresponding AB test
 */
const shouldBlockerBeUsed = () => AppOptionsService.getExperimentValue(AB_TEST) !== null

/**
 * Blocks History API navigation to the course page with ID 4026 and performs
 * the redirect with full reload
 */
const blocker: HistoryBlocker = ({ pathname }) => {
  if (!AB_TEST_COURSE_LANDING_REGEXP.test(pathname)) {
    return undefined
  }

  setTimeout(() => {
    window.location.href = pathname
  }, 0)

  return false
}

export const abTest20210618_16324Blocker: HistoryBlockerObject = { blocker, shouldBlockerBeUsed }
